import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Select } from 'components/fields'
import { apiCommon } from 'helpers/decorators/api'

@apiCommon({
  countries: true,
})
class Country extends Component {
  static propTypes = {
    resetAward: PropTypes.bool,
    common: PropTypes.object.isRequired,
    change: PropTypes.func,
    formPrefix: PropTypes.string,
    disabled: PropTypes.bool
  }

  static defaultProps = {
    formPrefix: 'person.address',
    resetAward: true,
  }

  handleFieldsReset = () => {
    if (this.props.resetAward) {
      this.props.change('awards[0].organization.id', null)
      this.props.change('awards[0].organization.name', null)
    }
  }

  render() {
    const { common, disabled, formPrefix } = this.props
    const prefix = formPrefix ? `${formPrefix}.country.id` : 'country.id'

    return (
      <Select
        disabled={disabled}
        label="Country"
        intlKey="label.country"
        name={prefix}
        options={common.countries.list}
        onSelectChange={this.handleFieldsReset}
        searchable
      />
    )
  }
}

export default Country
